const logout = () => {
  setSession(null, null);
};

export const setSession = (
  idToken: string | null,
  accessToken: string | null,
): void => {
  if (idToken) {
    localStorage.setItem('idToken', idToken);
  } else {
    localStorage.removeItem('idToken');
  }
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);
  } else {
    localStorage.removeItem('accessToken');
  }
};

export { logout };
